import { Roles } from "../../constants/roles";

export class MaximizeViewerRender {
    public static buildModal(): HTMLElement {
        const wrapper = document.createElement("div");
        wrapper.innerHTML = `
            <div
                class="maximize-viewer-modal"
                data-role="${Roles.MAXIMIZE_VIEWER_MODAL}"
                hidden
                role="dialog"
                aria-modal="true"
                aria-label="เครื่องเล่นสื่อ"
                data-translate-aria-label="sns_maximize_dialog_label">
                <div class="maximize-viewer-modal__backdrop" data-role="${Roles.MAXIMIZE_VIEWER_BACKDROP}"></div>
                <div class="maximize-viewer-modal__body">
                    <button
                        type="button"
                        class="btn circle-clear modal-window element-modal-close maximize-viewer-modal__close"
                        aria-label="ปิด"
                        data-translate-aria-label="modal_close"
                        data-role="${Roles.MAXIMIZE_VIEWER_CLOSE}">&times;</button>
                    <iframe
                        class="maximize-viewer-modal__iframe"
                        data-role="${Roles.MAXIMIZE_VIEWER_IFRAME}"
                        title="เนื้อหา SNS"
                        data-translate-title="sns_maximize_iframe_title"
                        allowfullscreen
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                        frameborder="0"
                        hidden></iframe>
                    <img
                        class="maximize-viewer-modal__image"
                        data-role="${Roles.MAXIMIZE_VIEWER_IMAGE}"
                        alt="รูปภาพ"
                        hidden>
                    <video
                        class="maximize-viewer-modal__video"
                        data-role="${Roles.MAXIMIZE_VIEWER_VIDEO}"
                        controls
                        playsinline
                        hidden></video>
                </div>
            </div>
        `;
        return wrapper.firstElementChild as HTMLElement;
    }
}
